<template>
<v-app id="app">
    <!-- Main Toolbar -->
    <Toolbar />
    <v-progress-linear fixed :active="$store.state.main.loading" color="success" :indeterminate="true" class="ma-0" height="3" style="top: 102px;"></v-progress-linear>

    <!-- Routed content -->
    <transition appear name="fade">
        <v-content :class="backGround()($route.name)">
                <router-view />
        </v-content>
    </transition>

    <!-- Total used SnackBar   -->
    <v-snackbar v-model="snackbar().model" :color="snackbar().color" :timeout="snackbar().timeout || 4000">
        <v-icon color="white">{{snackbar().icon}}</v-icon> {{snackbar().text}}
    </v-snackbar>

    <!-- Footer -->
    <Footer />
</v-app>
</template>

<script>
import Toolbar from '@/components/Toolbar.vue'
import Footer from '@/components/Footer.vue'
import {
    mapGetters,
    mapActions
} from 'vuex'

export default {
    name: 'App',
    components: {
        Toolbar,
        Footer
    },
    data() {
        return {
            ...mapGetters(['snackbar', 'userInfo', 'backGround']),
        }
    },
    watch: {},
    mounted() {
        
    },
    methods: {
        ...mapActions(['getReferenceList','getUserInfo'])
    },
    computed: {
    },
    created() {
        (async () => {
            await this.$recaptchaLoaded()
            const recaptcha = this.$recaptchaInstance
            // Hide reCAPTCHA badge:
            recaptcha.hideBadge()
        })()
    },
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.login-background {
/* background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("/img/login.d6d3bb09.jpg");*/
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}

.admin-panel-background {
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3)), url("/img/tower_bridge.jpg");
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}

.megogo-home-background {
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.6)), url("/img/film.jpg");
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}

.youtv-home-background {
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.6)), url("/img/film.jpg");
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}

</style>

<style lang="scss">
@import '@/styles/index.scss';
</style>
